import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveRefundList } from "./retrieve-refund-list";
import type { RefundVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<RefundVM[]> = { fetching: "idle", data: [] };

export const retrieveRefundListReducer = createReducer<RetrievalState<RefundVM[]>>(initialState, builder => {
  builder.addCase(retrieveRefundList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveRefundList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveRefundList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
